export default "__VITE_ASSET__Bfulc8Mz__"